<div class="card m-1 p-3 animate__animated animate__fadeIn">
  <div class="card-body">
    <ng-container *ngIf="showGifSuccess; else card">
      <div
        class="text-center card-check align-items-center d-flex justify-content-center flex-column"
      >
        <img
          class="animate__animated animate__fadeIn check"
          src="../../../assets/images/check.png"
        />

        <p class="note-send">{{ "Observación enviada" | translate }}</p>
      </div>
    </ng-container>
    <ng-template #card class="animate__animated animate__fadeIn">
      <div class="row justify-content-between mb-3">
        <p class="col-md-6 col-5 title-header">
          {{ "Campo profesional" | translate }}
        </p>
        <select
          (change)="changeProfessionalCategory($event)"
          class="select col-7 col-md-6"
          [(ngModel)]="profesional_category"
        >
          <option selected value="" disabled>
            {{ "Seleccione" | translate }}
            <i class="fa-solid fa-angle-down"></i>
          </option>
          <option value="Enfermería">{{ "Enfermería" | translate }}</option>
          <option value="Medicina">{{ "Medicina" | translate }}</option>
          <option value="Técnico sanitario">
            {{ "Técnico sanitario" | translate }}
          </option>
          <option value="Fisioterapia">
            {{ "Fisioterapia" | translate }}
          </option>
          <option value="Odontología">
            {{ "Odontología" | translate }}
          </option>
          <option value="Celador">
            {{ "Celador" | translate }}
          </option>
          <option value="Otros">
            {{ "Otros" | translate }}
          </option>
        </select>
      </div>
      <div class="row justify-content-between">
        <p class="col-6 title-header">
          {{ "Perfil profesional" | translate }}
        </p>
        <select class="select col-6" [(ngModel)]="code">

          <option [value]="item" *ngFor="let item of listprofessionalProfile">
            {{ item | translate }}
          </option>
        </select>
      </div>
      <!-- /////////////// -->
      <div class="row mt-4">
        <div class="col-7">
          <p class="title-header">
            {{ "INDICACIÓN" | translate }}
          </p>
          <div
            class="custom-control custom-checkbox mt-3"
            *ngFor="let check of checksIndications; let i = index"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              [id]="check.id"
              [(ngModel)]="noteData[check.secondaryId]"
            />
            <label class="custom-control-label" [for]="check.id">
              {{ i + 1 }} - {{ check.name }}</label
            >
          </div>
        </div>
        <div class="col">
          <p class="title-header  mr-5">
            {{ "ACCIÓN" | translate }}
          </p>
          <div
            class="custom-control custom-checkbox custom-radiobutton"
            *ngFor="let check of checksAccions"
          >

          
            <input
              (change)="handleChange($event)"
              [name]="check.group"
              type="radio"
              class="radio-custom"
              [value]="check.id"
              [id]="check.id"
            />
            <label class="radio-custom-label" [for]="check.id">{{
              check.name
            }}</label>

            <div
              [ngStyle]="{
                'margin-left': '2rem'
              }"
              class="custom-control custom-checkbox"
              *ngFor="let children of check.children"
            >
              <ng-container *ngIf="children.father == accionRadio">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [value]="children.id"
                  [id]="children.id"
                  [(ngModel)]="noteData[children.secondaryId]"
                />
                <label class="custom-control-label" [for]="children.id">{{
                  children.name
                }}</label>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-end mt-4">
        <button (click)="sendObservationNote()" class="btn btn-primary">
          {{ "Enviar observación" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
